exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".binding-group-extra-renderer {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n", ""]);

// exports
